import { render } from "./art.vue?vue&type=template&id=22656af2&scoped=true"
import script from "./art.vue?vue&type=script&lang=js"
export * from "./art.vue?vue&type=script&lang=js"

import "./art.vue?vue&type=style&index=0&id=22656af2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22656af2"]])

export default __exports__